<template>
  <div
    class="card-container appoint-visit-form car-info"
    :class="{ 'modal-mode': modalMode === 'logged-in' }"
  >
    <form class="top-wrapper">
      <div class="input-container">
        <standard-input
          :value="vin.toUpperCase()"
          :maxlength="17"
          required
          :autofocus="true"
          @input_change="onVinInput($event)"
          @input_focus="onFocus()"
          @input_blur="onBlur()"
          name="vin"
          label="Numer VIN"
        />
      </div>
      <standard-select
        class=""
        label-text="Model"
        :arrow-color="buttonColor"
        :value="selectedModel"
        required
        @selected="onModelSelected($event)"
        @select_mounted="selectedModel = ''"
        :options="modelOptions"
        :disabled="!disableSelect"
      />
    </form>
    <div
      class="login-alert-box vin-validation-box"
      v-if="message"
    >
      {{ message }}
    </div>
    <div class="bottom-wrapper">
      <standard-button
        text="Dalej"
        :disabled="!buttonDisabled"
        custom-class="next-button"
        :loading="loading"
        @buttonClick="next()"
      />
    </div>
    <step-indicator :step="1" />
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import StandardSelect from '~/StandardSelect';
import StandardInput from '~/StandardInput';
import StepIndicator from '~/StepIndicator';
import { mapGetters, mapActions } from 'vuex';
import config from '@/config';
import axios from 'axios';

export default {
  components: {
    StandardButton,
    StandardSelect,
    StandardInput,
    StepIndicator,
  },
  data() {
    return {
      vin: '',
      selectedModel: '',
      loading: false,
      message: '',
      filteredByVin: [],
      inputFocus: false,
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      buttonColor: 'brand/getThirdColor',
      allModels: 'brand/getBrandModels',
      chosenCarSpecs: 'car/getChosenCarSpecs',
      modalMode: 'modal/getModalMode',
      authStatus: 'auth/getAuthStatus',
      allCars: 'brand/getSpecificModels',
    }),
    withLogin() {
      return this.authStatus.loggedIn;
    },
    buttonDisabled() {
      return !!this.selectedModel;
    },
    disableSelect() {
      const condition = this.vinValid && this.vin && this.modelOptions.length;
      return condition;
    },
    vinValid() {
      // audi vin regex
      const regex = /^(wau|wua|tru|aaa|93u|wa1|wac)+(zzz)+[a-z0-9]{11}/gi;
      return this.vin.length && regex.test(this.vin);
    },
    modelOptions() {
      if (this.vinValid) {
        return [...new Set(this.filteredByVin.map(car => car.model.toLowerCase()))];
      }
      return [];
    },
  },
  methods: {
    ...mapActions({
      setFilters: 'car/setFilters',
      resetCarSpecs: 'car/resetCarSpecs',
      setVinNumber: 'car/setVinNumber',
      setModel: 'car/setModel',
      setModalStep: 'modal/setModalStep',
      filterCars: 'car/filterCars',
      resetFilters: 'car/resetFilters',
      setTransmission: 'car/setTransmission',
      setEngine: 'car/setEngine',
      setCapacity: 'car/setCapacity',
      setPower: 'car/setPower',
      setModalContent: 'modal/setContent',
    }),
    onModelSelected(value) {
      this.setModel(value);
      this.setEngine('');
      this.setCapacity('');
      this.setPower('');
      this.setTransmission('');
      this.setFilters({ type: 'model', value });
      this.filterCars();

      this.selectedModel = value;
    },
    onVinInput(value) {
      this.vin = value;
      this.setVinNumber(value);
    },
    next() {
      this.setModalContent({
        title: !this.withLogin ? 'Umów się na wizytę' : 'Dodaj samochód',
        subtitle: 'Podaj parametry Twojego samochodu',
      });
      this.setModalStep('second_step');
    },
    onFocus() {
      this.inputFocus = true;
    },
    onBlur() {
      this.inputFocus = false;
    },
    handleKeyDown(event) {
      const { keyCode } = event;

      if (keyCode === 13 && this.buttonDisabled) {
        this.next();
      }

      if (!this.inputFocus) {
        if (keyCode === 8) {
          this.setModalStep('first_step');
        }
      }
    },
  },
  watch: {
    vinValid(newVal) {
      this.selectedModel = '';

      if (newVal) {
        const params = {
          vin: this.vin,
        };
        this.loading = true;
        this.message = '';

        axios.get(config.apiUrl + config.apiEndpoints.carModels, { params })
          .then((res) => {
            if (res.data.length) {
              this.filteredByVin = res.data;
              if (this.modelOptions.length === 1) {
                this.onModelSelected(this.modelOptions[0]);
              }
            }
            if (!res.data.length) {
              this.message = 'Nie odnaleziono modelu dla podanego numeru VIN';
              this.filteredByVin = this.allCars;
            }
            this.loading = false;
          })
          .catch((err) => {
            if (err.response.data.message === 'Suma kontrolna numeru VIN jest nieprawidłowa') {
              this.message = 'Nieprawidłowy numer VIN';
              this.filteredByVin = [];
            } else {
              this.message = err.response.data.message;
            }
            this.loading = false;
          });
      }
    },
    vin() {
      setTimeout(() => {
        if (!this.vinValid) {
          this.message = 'Nieprawidłowy numer VIN';
        }
        if (!this.vin.length) {
          this.message = '';
        }
      }, 1000);
    },
  },
  mounted() {
    this.setModalContent({
      title: !this.withLogin ? 'Umów się na wizytę' : 'Dodaj samochód',
      subtitle: 'Podaj parametry Twojego samochodu',
    });
    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
